// Module
var code = `<!-- CLOSING CTA -->
<section class="landing-cta" aria-labelledby="landing-cta-headline">

    <div class="landing-cta__block">

        <div class="landing-cta__glow" aria-hidden="true"></div>

        <h2 id="landing-cta-headline" class="landing-cta__headline">
            SpyneJS gives you new structural <br/>logic for building with AI.
        </h2>

        <p class="landing-cta__sub">
            SpyneJS is open source, production-ready, and built for developers who want
            to understand what they're building — and work with AI without losing that clarity.
        </p>

        <div class="landing-cta__buttons">

            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="configure"
                href="/configure"
                class="btn btn--primary">Generate my first app</a>
            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="docs"
                data-text="Docs"
                href="/docs/examples"
                class="btn btn--secondary">Read the docs</a>
            <a  target="_blank" href="https://github.com/spynejs" class="btn btn--secondary">View on GitHub</a>



        </div>

        <p class="landing-cta__footnote">
            Framework is LGPL-3 open source. Docs, CLI, and Behavior Console are always free.
        </p>

    </div>

</section>
`;
// Exports
module.exports = code;